<div class="sort-dropdown">
  <div class="label" [class.selected]="isOpen" (click)="toggleDropdown()">
    <span class="text">{{ 'Sort By' }}</span>
    <span class="arrow" [class.open]="isOpen"></span>
  </div>

  <ul class="options" *ngIf="isOpen">
    <li
      *ngFor="let opt of sortOptions"
      (click)="onSelect(opt)"
      [class.selected]="opt.value === selectedSort?.value"
    >
      {{ opt.label }}
    </li>
  </ul>
</div>
